/**
 * Copyright (c) 2021 TechDivision GmbH
 * All rights reserved
 */

/**
 * Helper to work with objects within localStorage
 * @class LocalStorageObjectHelper
 */
export default class LocalStorageObjectHelper {
    // What identifier is used from localStorage
    constructor(storageIdentifier) {
        this.storageIdentifier = storageIdentifier
    }

    // Get data as object
    get data() {
        return localStorage.getItem(this.storageIdentifier)
            ? JSON.parse(localStorage.getItem(this.storageIdentifier))
            : []
    }

    // Get search as one single item of object
    get(search) {
        return this.data.find((element) => element.productIdentifier === search)
    }

    // Find all with same product identifier
    findAll(search) {
        return this.data.filter((element) => element.productIdentifier === search)
    }

    // Add an item to object as
    add(value) {
        let data = this.data
        if (data.length < 3) {
            data.push(value)
            localStorage.setItem(this.storageIdentifier, JSON.stringify(data))
            return data
        }
    }

    // Transform array and set to localstorage
    delete(identifier) {
        let data = this.data
        const occurrence = data.map(this.deleteStrategy).indexOf(identifier)
        if (occurrence >= 0) {
            data.splice(occurrence, 1)
            localStorage.setItem(this.storageIdentifier, JSON.stringify(data))
            return data
        }
    }

    // Replace item by identifier with given item object
    replace(identifier, value) {
        if (this.delete(identifier)) {
            if (this.add(value)) {
                return this.data
            }
        }
    }

    /// Overwrite full data of storage object
    overwrite(data) {
        localStorage.setItem(this.storageIdentifier, JSON.stringify(data))
    }

    // Delete Strategy can be overwritten
    deleteStrategy(element) {
        return element.productIdentifier
    }
}
